<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.19118 13.6177C4.87765 13.6177 3 15.4953 3 17.8088C3 20.1224 4.87765 22 7.19118 22C9.50471 22 11.3824 20.1224 11.3824 17.8088C11.3824 15.4953 9.50471 13.6177 7.19118 13.6177ZM9.25882 17.0824L7.02353 19.3177C6.92294 19.4294 6.77765 19.4853 6.63235 19.4853C6.48706 19.4853 6.34176 19.4294 6.24118 19.3177L5.12353 18.2C4.9 17.9877 4.9 17.63 5.12353 17.4177C5.33588 17.1941 5.69353 17.1941 5.90588 17.4177L6.63235 18.133L8.47647 16.3C8.68882 16.0765 9.04647 16.0765 9.25882 16.3C9.48235 16.5124 9.48235 16.87 9.25882 17.0824Z"
      :fill="
        currentScreen === tabRoutes.DEPOSITS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M21.5082 6.84469C21.1953 6.53175 20.7594 6.35292 20.3235 6.35292H4.67647C4.24059 6.35292 3.80471 6.53175 3.49176 6.84469C3.17882 7.15763 3 7.58233 3 8.02939V14.59C3.97235 13.327 5.48118 12.5 7.19118 12.5C10.1194 12.5 12.5 14.8806 12.5 17.8088C12.5 18.5017 12.3547 19.1612 12.12 19.7647H20.3235C20.7594 19.7647 21.1953 19.5859 21.5082 19.2729C21.8212 18.96 22 18.5241 22 18.0882V8.02939C22 7.58233 21.8212 7.15763 21.5082 6.84469ZM16.9706 15.2941C15.4282 15.2941 14.1765 14.0423 14.1765 12.5C14.1765 10.9576 15.4282 9.70586 16.9706 9.70586C18.5129 9.70586 19.7647 10.9576 19.7647 12.5C19.7647 14.0423 18.5129 15.2941 16.9706 15.2941Z"
      :fill="
        currentScreen === tabRoutes.DEPOSITS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M19.0271 4.67647V5.23529H4.67647C4.06176 5.23529 3.48059 5.44765 3 5.80529V4.67647C3 3.74882 3.74882 3 4.67647 3H17.3506C18.2782 3 19.0271 3.74882 19.0271 4.67647Z"
      :fill="
        currentScreen === tabRoutes.DEPOSITS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
    <path
      d="M16.9706 14.1764C17.8965 14.1764 18.6471 13.4259 18.6471 12.5C18.6471 11.5741 17.8965 10.8235 16.9706 10.8235C16.0447 10.8235 15.2941 11.5741 15.2941 12.5C15.2941 13.4259 16.0447 14.1764 16.9706 14.1764Z"
      :fill="
        currentScreen === tabRoutes.DEPOSITS
          ? 'var(--main-color)'
          : 'var(--white-color)'
      "
    />
  </svg>
</template>

<script setup>
import {computed} from 'vue';
import {useStore} from 'vuex';

import {tabRoutes} from '@/routes';

const store = useStore();

const currentScreen = computed(() => store.getters['tab/screen']);
</script>
